export function createCookieConsentFeature() {
    function getCookieValue(name) {
        const cookies = document.cookie ? document.cookie.split("; ") : [];

        for (const cookie of cookies) {
            if (cookie.indexOf(name + "=") === 0) {
                return cookie.substring(name.length + 1);
            }
        }

        return "";
    }

    function setCookie(name, value, days) {
        const maxAge = Math.max(1, Number(days) || 365) * 24 * 60 * 60;
        document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`;
    }

    function init() {
        document.addEventListener("click", handleAcceptClick);
    }

    function destroy() {
        document.removeEventListener("click", handleAcceptClick);
    }

    function handleAcceptClick(event) {
        const acceptButton = event.target.closest("[data-tygrys-cookie-accept]");
        if (!acceptButton) {
            return;
        }

        event.preventDefault();

        const box = acceptButton.closest("[data-tygrys-cookie-box]");
        if (!box) {
            return;
        }

        const cookieName = box.getAttribute("data-tygrys-cookie-name") || "tygrys_cookie_consent";
        const cookieValue = box.getAttribute("data-tygrys-cookie-value") || "accepted";
        const cookieDays = box.getAttribute("data-tygrys-cookie-days") || "365";

        if (getCookieValue(cookieName) !== cookieValue) {
            setCookie(cookieName, cookieValue, cookieDays);
        }

        box.setAttribute("hidden", "hidden");
    }

    return {
        init,
        destroy,
    };
}
